import { render } from "./About.vue?vue&type=template&id=363ac799&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=363ac799&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-363ac799"

export default script